import React, { useCallback } from 'react';
import { useModalStore } from '@/store/useModalStore';
import { Dropdown } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import styles from './index.module.scss';

export interface AixueFooterProps {}

export default function AixueFooter(props: AixueFooterProps) {
  const navigate = useNavigate();
  const { openModalMask } = useModalStore();
  // 仅负责回到顶部，与路由跳转（Link）解耦
  const scrollToTopDeferred = useCallback(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const selectors = [
          '.aixue-home-scroll',
          '[data-scroll-root="aixue-phonics"]',
          '.aixue-about-scroll',
          '.aixue-join-scroll',
        ];
        for (const sel of selectors) {
          const node = document.querySelector(sel) as HTMLElement | null;
          if (node) node.scrollTo({ top: 0, behavior: 'auto' });
        }
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    });
  }, []);

  const footerProductsItems = [
    {
      key: 'products-phonics',
      label: (
        <span onClick={() => navigate('/aixue-phonics')}>
          爱学AI自然拼读
        </span>
      ),
    },
    {
      key: 'products-ai',
      label: (
        <span onClick={() => navigate('/aixue-ai')}>
          爱学AI一对一导师
        </span>
      ),
    },
  ];

  return (
    <footer className={styles['footer-cover']}>
      <div className={styles['footer-wrap']}>
        <div className={styles['footer-left']}>
          <div className={styles.logo}></div>
          <div className={styles['nav']}>
            <Link to="/" className={styles['nav-item']} onClick={scrollToTopDeferred}>
              首页
            </Link>

            <Dropdown
            trigger={["hover"]}
            menu={{ items: footerProductsItems }}
            overlayClassName="aixue-bottom-menu-overlay"
            placement="bottom"
            mouseLeaveDelay={0.4}
          >
            <span className={`aixue-menu-link ${styles['nav-item']}`}>
              产品中心
            </span>
          </Dropdown> 
            <Link to="/aixue-about" className={styles['nav-item']} onClick={scrollToTopDeferred}>
              关于我们
            </Link>
            <Link to="/aixue-join" className={styles['nav-item']} onClick={scrollToTopDeferred}>
              加入我们
            </Link>
            <span className={styles['nav-item']} onClick={() => openModalMask('download-center')}>
              下载中心
            </span>
          </div>
          <div className={styles['meta']}>
            <span>北京与爱为舞科技有限公司 版权所有</span>
            <span className={styles['meta-item']}>京公网安备11010802046217号</span>
            <span>京ICP备2023011465号-2</span>
          </div>
        </div>

        <div className={styles['footer-right']}>
          <div className={styles['footer-text']}>关注我们</div>
          <div className={styles['socials']}>
            <div className={`${styles['social-btn']} ${styles['social-btn1']}`}>
              <div className={styles['social-btn-qr']}>
                <div className={styles['social-icon']}></div>
              </div>
            </div>
            <div className={`${styles['social-btn']} ${styles['social-btn2']}`}>
              <div className={styles['social-btn-qr']}>
                <div className={styles['social-icon']}></div>
              </div>
            </div>
            <div
              className={`${styles['social-btn']} ${styles['social-btn3']}`}
              onClick={() =>
                window.open(
                  'https://www.xiaohongshu.com/user/profile/68789009000000001e03ecd4',
                  '_blank',
                  'noopener,noreferrer',
                )
              }
            ></div>
          </div>
        </div>
      </div>
    </footer>
  );
}
